var chunkToChildrenMap = {
	"56": [
		982,
		870,
		720,
		894
	],
	"102": [
		689,
		494
	],
	"494": [
		500
	],
	"870": [
		102,
		390
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };